<div class="rounded">
  <div class="row mt-2 mx-2 pb-3 border-bottom justify-content-between ">
    <div class="pl-3 d-flex align-items-center">
      <i
        class="far fa-filter"
        [attr.aria-label]="'IMAGE_DESCRIPTION.FILTER' | translate"
      ></i>
      <span class="font-weight-bold ml-2 text-primary">
        {{ filteredItem?.displayCode || filteredItem?.name }}
      </span>
    </div>
    <form autocomplete="off" [formGroup]="formUser" class="position-relative pr-1 justify-content-end d-flex">
      @if (portfolioLevel) {
        <div class="d-flex flex-column mx-1">
          @if (!allPlantsSelected) {
            <input
              type="text"
              [placeholder]="'HEADER.ADD_NEW_PORTFOLIO_NAME' | translate"
              [(ngModel)]="config.name"
              formControlName="portFolioName"
              class="form-control portfolio-title px-2"
              [class.is-invalid]='getValidationPortfolioName()'>
          }
          @if (!allPlantsSelected && getValidationPortfolioName()) {
            <span class="text-danger position-absolute"
              [ngStyle]="{ bottom: '-1.1rem', left: '0.25rem' }">
              <small>{{"USER_PREFERENCES.USER_PORTFOLIO.MIN_NAME_PORTFOLIO" |translate}}</small>
            </span>
          }
        </div>
      }
      @if (portfolioLevel) {
        <div class="mx-1">
          @if (!allPlantsSelected) {
            <lib-button
              id="header-filter-save-portfolio"
              class="mr-2"
              [size]="'medium'"
              [label]="'HEADER.SAVE_AS_NEW_PORTFOLIO' |translate"
              [disabled]="!config.name || nonePlantsSelected || getValidationPortfolioName()"
              (buttonClicked)="saveNewPortfolio()" >
            </lib-button>
          }
        </div>
      }
      @if (portfolioLevel) {
        <div class="plants-sorting-container mx-1">
          <lib-select
            id="header-filter-sort-portfolio"
            [options]="inputsSortOptions"
            [label]="selectedInputLabel"
            [border]="'custom-border'"
            [classes]="'font-size-normal-small text-primary h-100'"
            [notBold]="true"
            [fullWidth]="true"
            [itemClasses]="'font-size-normal-small'"
            [container]="''"
            (selectedChanged)="sortPlantsBy($event)">
          </lib-select>
        </div>
      }
      <div class="d-flex">
        @if (!portfolioLevel) {
          <input type="text" [placeholder]="'HEADER.SEARCH' | translate" class="search-asset-filter pl-2 mr-1 {{theme}}" (input)="filterByNameEvent($event)"/>
        }
        <div class="plants-sorting-container mx-1">
          <lib-select
            id="header-filter-show-portfolio"
            [options]="inputsShowOptions.names"
            [label]="statusSelected"
            [border]="'custom-border'"
            [classes]="'plants-sorting-container font-size-normal-small text-primary h-100'"
            [notBold]="true"
            [fullWidth]="true"
            [itemClasses]="'font-size-normal-small'"
            [container]="''"
            (selectedChanged)="changeStatus($event)">
          </lib-select>
        </div>
      </div>
      <div class="p-1 mx-1 custom-border cursor-pointer action-button">
        @if (!config.sticky) {
          <img [alt]="'IMAGE_DESCRIPTION.TOGGLE_PIN' | translate"  src="assets/images/pin/{{theme === 'light' ? 'pin-dark.svg' : 'pin-light.svg'}}" (click)="pinToggle()">
        }
        @if (config.sticky) {
          <img  [alt]="'IMAGE_DESCRIPTION.TOGGLE_PIN' | translate" src="assets/images/pin/{{theme === 'light' ? 'pinned-dark.svg' : 'pinned-light.svg'}}" (click)="pinToggle()">
        }
      </div>
      @if (portfolioLevel) {
        <div class="p-1 mx-1 custom-border cursor-pointer action-button">
          <i class="far fa-ellipsis-h {{ theme }}"
            [attr.aria-label]="'IMAGE_DESCRIPTION.MORE' | translate"
            role="img"
            [popover]="moreTemplate"
            (onShown)="shownPopover = true"
            [isOpen]="shownPopover"
            containerClass="more-container"
            placement="bottom"
            #morePopover="bs-popover">
          </i>
        </div>
      }
    </form>
  </div>
  @if (portfolioLevel) {
    <div class="row my-2 px-2 pt-2 pb-4 border-bottom">
      <div class="col-12 d-flex">
        <div class="row">
          <div class="p-2 m-1 custom-border" style="min-height: 40px; min-width: 155px">
            <app-check-box
              (valueChange)="selectAllPlants()"
              [value]="allPowerplantsSelected"
              [labelClasses]="'custom-font-size text-primary font-weight-bold'"
              [nameInput]="'HEADER.ALL_PLANTS' | translate">
            </app-check-box>
          </div>
          @for (country of countries | keyvalue; track $index) {
            <div class="p-2 m-1 custom-border" style="min-height: 40px; min-width: 155px">
              <div class="row">
                <div class="col-10" (click)="!isCountryDeactivated(country.key) ? selectCountry(country, $event) : false">
                  <app-check-box
                    [value]="country.value"
                    [disabled]="isCountryDeactivated(country.key)"
                    [labelClasses]="calcLabelClasses(country.key)"
                    [nameInput]="('COUNTRIES.'+ country.key) | translate">
                  </app-check-box>
                </div>
                <div class="col-2">
                  <lib-country-flag [countryShortname]="country.key"></lib-country-flag>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (portfolioLevel) {
    <div class="row rounded p-2 clickable">
      @for (powerplant of filteredItem?.powerplants; track $index) {
        <div>
          <div class="p-2 m-1 custom-border" style="min-height: 40px; min-width: 155px">
            <div class="row">
              <div class="col-10">
                <label class="text-primary font-size-normal m-0 font-weight-bold" (click)="selectPlant(powerplant, $event)">
                  <app-check-box
                    [value]="powerplant?.selected"
                    [disabled]="isCountryDeactivated(powerplant.countryCode)"
                    [labelClasses]="calcLabelClasses(powerplant.countryCode)"
                    [nameInput]="powerplant?.displayCode || powerplant?.name">
                  </app-check-box>
                </label>
              </div>
              <div class="col-2 d-flex align-items-center">
                @if (signalType === 'status' && !isParkDeactivated(powerplant.id)) {
                  <i
                    class="fas fa-circle align-self-center" [ngClass]="{ 'outline-circle': powerplant?.state === 5 }"
                    [style.color]="powerplant?.state | colorStatusCode: 'color'">
                  </i>
                }
                @if (signalType === 'load') {
                  <span>
                    <app-load-factor [loadFactor]="powerplant?.loadFactor"></app-load-factor>
                  </span>
                }
                @if (signalType === 'efficiency') {
                  <div class="efficiency-container">
                    <app-efficiency [efficiency]="powerplant?.efficiency"></app-efficiency>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (!portfolioLevel) {
    <div class="row my-2 px-2 pt-2 pb-3 border-bottom header-filter-container">
      <div class="col-12 d-flex">
        <div class="p-2 m-1 custom-border" style="min-height: 40px; min-width: 155px">
          <app-check-box
            (valueChange)="selectAllTurbines()"
            [value]="allTurbSelected"
            [labelClasses]="'custom-font-size text-primary font-weight-bold'"
            [nameInput]="'HEADER.ALL_TURBINES' | translate">
          </app-check-box>
        </div>
        <div class="device-groups-list m-1" >
          @for (group of deviceGroupList; track $index) {
            <div>
              <div class="cursor-pointer custom-border py-2 px-2 mx-1" style="min-height: 40px; min-width: 155px">
                <app-check-box
                  (valueChange)="selectTurbinesGroup(group)"
                  [value]="group.selected"
                  [labelClasses]="'font-size-very-small text-primary font-weight-bold no-wrap'"
                  [nameInput]='group.name'>
                </app-check-box>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (!portfolioLevel) {
    <div class="row rounded p-2 clickable">
      @for (turbine of filteredItem?.turbines; track $index) {
        <div
          [style.display]="showFilteredTurbine(turbine?.codeDisplay | noUnderscore) ? 'flex' : 'none'">
          <div class="p-2 m-1 custom-border" style="min-height: 40px; min-width: 155px">
            <div class="row">
              <div class="col-10">
                <label class="text-primary font-size-normal m-0 font-weight-bold"  (click)="selectTurbine(turbine, $event)">
                  <app-check-box
                    [value]="turbine.selected"
                    [labelClasses]="'custom-font-size text-primary font-weight-bold'"
                    [nameInput]="(turbine?.codeDisplay | noUnderscore)">
                  </app-check-box>
                </label>
              </div>
              <div class="col-2 d-flex align-items-end pb-1">
                @if (signalType === 'status' && !isTurbineDeactivated(turbine.id)) {
                  <i
                    class="fas fa-circle align-self-center" [ngClass]="{ 'outline-circle': turbine?.state === 5 }"
                    [style.color]="turbine?.state | colorStatusCode: 'color'"
                  ></i>
                }
                @if (signalType === 'load') {
                  <span>
                    <app-load-factor [loadFactor]="turbine?.loadFactor"></app-load-factor>
                  </span>
                }
                @if (signalType === 'efficiency') {
                  <div class="efficiency-container">
                    <app-efficiency [efficiency]="turbine?.efficiency"></app-efficiency>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <ng-template #moreTemplate>
    <button
      class="btn btn-default text-primary"
      [disabled]="filteredItem?.id === defaultId"
      (click)="modalServiceWindow(modalTemplate)">
      {{"HEADER.DELETE_PORTFOLIO" | translate}}
    </button>
  </ng-template>

  <!--MODAL DELETE WINDOW-->
  <ng-template #modalTemplate>
    <div class="modal-header d-flex align-items-center">
      <h6 class="modal-tittle text-primary font-weight-bold m-0">
        {{"HEADER.DELETE_PORTFOLIO" | translate}}
      </h6>
      <span class="clickable close" (click)="hideModalServiceWindow()">&times;</span>
    </div>
    <div class="modal-body">
      <div class="text-left text-primary">
        {{"USER_PREFERENCES.USER_PORTFOLIO.YOU_ARE_ABOUT_TO_DELETE" | translate}}<br/>
        <b>{{ "USER_PREFERENCES.USER_PORTFOLIO.PROCEED" | translate }}</b>
      </div>
    </div>
    <div class="modal-footer">
      <lib-button
        id="header-filter-cancel-button"
        class="mr-2"
        [size]="'large'"
        [color]="'secondary'"
        [label]="'BUTTONS.CANCEL' |translate"
        (buttonClicked)="hideModalServiceWindow()" >
      </lib-button>

      <lib-button
        id="header-filter-delete-portfolio-button"
        class="mr-2"
        [size]="'large'"
        [label]="'HEADER.DELETE_PORTFOLIO' |translate"
        (buttonClicked)="deletePortfolio()" >
      </lib-button>
    </div>
  </ng-template>
